import * as React from "react"
import { ChevronLeft, ChevronRight } from "lucide-react"
import { DayPicker } from "react-day-picker"

import { cn } from "@/lib/utils"
import { buttonVariants } from "@/components/ui/button"

function Calendar({
  className,
  classNames,
  showOutsideDays = true,
  ...props
}) {
  return (
    <DayPicker
      showOutsideDays={showOutsideDays}
      className={cn("p-3", className)}
      style={{
        "--rdp-accent-color": "hsl(var(--accent))",
        "--rdp-accent-background": "hsl(var(--accent) / 0.1)",
        "--rdp-range_start-color": "hsl(var(--accent))",
        "--rdp-range_end-color": "hsl(var(--accent))",
        "--rdp-range_middle-background": "hsl(var(--accent) / 0.15)",
        "--rdp-range_middle-color": "hsl(var(--foreground))",
        "--rdp-selected-color": "white",
        "--rdp-selected-background": "hsl(var(--primary))",
      }}
      {...props}
    />
  );
}
Calendar.displayName = "Calendar"

export { Calendar }
